import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalEmployeeConfigDocument = gql`
  query SalesPortalEmployeeConfig($supplierUUID: uuid!, $userUUID: uuid!) {
    businesses_by_pk(uuid: $supplierUUID) {
      businesses_employees(where: { employee_uuid: { _eq: $userUUID } }) {
        employee_config
        uuid
      }
    }
  }
`;
export function useSalesPortalEmployeeConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalEmployeeConfigQuery,
    Types.SalesPortalEmployeeConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalEmployeeConfigQuery,
    Types.SalesPortalEmployeeConfigQueryVariables
  >(SalesPortalEmployeeConfigDocument, options);
}
export function useSalesPortalEmployeeConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalEmployeeConfigQuery,
    Types.SalesPortalEmployeeConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalEmployeeConfigQuery,
    Types.SalesPortalEmployeeConfigQueryVariables
  >(SalesPortalEmployeeConfigDocument, options);
}
export type SalesPortalEmployeeConfigQueryHookResult = ReturnType<
  typeof useSalesPortalEmployeeConfigQuery
>;
export type SalesPortalEmployeeConfigLazyQueryHookResult = ReturnType<
  typeof useSalesPortalEmployeeConfigLazyQuery
>;
export type SalesPortalEmployeeConfigQueryResult = Apollo.QueryResult<
  Types.SalesPortalEmployeeConfigQuery,
  Types.SalesPortalEmployeeConfigQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalEmployeeConfigQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalEmployeeConfigQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalEmployeeConfigQuery,
    Types.SalesPortalEmployeeConfigQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalEmployeeConfigQuery,
    Types.SalesPortalEmployeeConfigQueryVariables
  >(SalesPortalEmployeeConfigDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalEmployeeConfigLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalEmployeeConfigLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalEmployeeConfigQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalEmployeeConfigQuery,
    Types.SalesPortalEmployeeConfigQueryVariables
  >(SalesPortalEmployeeConfigDocument, lazyOptions);
}
